import React from 'react';
import { SafeAreaView, View } from 'react-native';
export const ConditionalContainer = ({
  children,
  container,
  condition
}) => /*#__PURE__*/React.createElement(React.Fragment, null, condition ? container(children) : children);
export const IsSafeAreaWrapper = ({
  children,
  isSafeArea,
  ...props
}) => isSafeArea ? /*#__PURE__*/React.createElement(SafeAreaView, props, children) : /*#__PURE__*/React.createElement(View, props, children);
//# sourceMappingURL=ConditionalContainer.js.map